module.exports = __webpack_public_path__ + "static/media/clock-active.0a182e4e.svg";